<template>
  <el-dialog
      :visible="visible"
      @open="onOpen"
      :before-close="close"
      width="80%"
      :close-on-press-escape="false"
  >

    <div slot="title" class="el-dialog__title header">
     <span class="header__title">
       {{ diagnosticData.deviationField ? diagnosticData.deviationField.title : 'Разметчик' }}
     </span>

      <el-radio-group v-model="typeHeatMap">
        <el-radio-button v-for="mode in modes" :label="mode.id" :key="mode.id">{{ mode.title }}</el-radio-button>
      </el-radio-group>
    </div>

    <heat-map
        v-show="typeHeatMap === 1"
        :visible="visible"
        :controls="true"
        :points="points"
        :markup="getMarkup"
        :comments="getComments"
        :markupDiagnosisType="diagnosticData.markup_diagnosis_type"
        :deviceId="diagnosticData.deviceId"
        :deviationField="diagnosticData.deviationField"
        class="content_body"
        @onClose="close"
        v-loading="loading"
    />

    <similar-heat-map v-show="typeHeatMap === 2"/>
    <recognition-log v-show="typeHeatMap === 3"/>

  </el-dialog>
</template>

<script>
import HeatMap from "@/components/HeatMap/HeatMap"
import RecognitionLog from "@/components/HeatMap/RecognitionLog"
import SimilarHeatMap from "@/components/HeatMap/SimilarHeatMap"

export default {
  name: "ProjectPlanEditor",
  props: {
    results: {
      required: true,
    },
    comments: {
      required: true,
    },
    diagnosticData: {
      required: true
    },
    visible: {
      required: true
    },
    markup: {}
  },
  components: {
    HeatMap,
    SimilarHeatMap,
    RecognitionLog
  },
  data: () => ({
    plan: null,
    typeHeatMap: 1,
    loading: false,
    rooms: [],
    modes: [
      {
        id: 1,
        title: 'Разметка термограммы'
      },
      {
        id: 2,
        title: 'Похожие термограммы'
      },
      {
        id: 3,
        title: 'Журнал распознавания '
      }
    ]
  }),
  computed: {
    getMarkup() {
      if (!this.markup) return []
      return this.markup.filter(item => {
        return (item.device_id === this.diagnosticData.deviceId)
      })
    },
    points() {
      let files = []
      let markups = []
      if (!this.results) return
      if (!this.diagnosticData.allDiagnosticFields) return

      this.results.forEach(item => {
        if (this.diagnosticData.allDiagnosticFields.includes(item.diagnostic_field_id)) {
          files.push(item)
        }

      })
      return {
        files,
        markups
      }
    },
    getComments() {
      if (!this.comments) return {}

      let comments = {}
      this.comments.forEach(item => {
        if (item.device_id == this.diagnosticData.deviceId) {
          comments = item
          return
        }
      })

      return comments
    }
  },
  methods: {
    onOpen() {

    },
    close() {
      this.$emit('close')
    },
  }
}
</script>

<style lang="scss" scoped>
.modal {
  &__mask {
    position: fixed;
    z-index: 99;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
  }

  &__wrapper {
    display: table-cell;
    vertical-align: middle;
  }
}

.modal-content {
  max-width: 900px;
  height: 90%;
  margin: 0 auto;
  padding: 10px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  overflow-y: auto;
}

.modal-header {
  font-size: 24px;
  margin: 0;
  color: #5574a1;

  &__icon {
    float: right;
    cursor: pointer;
  }
}

.el-dialog__header {
  padding-top: 26px;
}

.header {
  margin: -32px -48px;
  padding: 32px 48px;

  display: flex;
  justify-content: start;
  align-items: center;
  gap: 24px;

  border-bottom: 1px solid #EAEAEA;

}

</style>
